import IntercomIcon from '../../../assets/img/backoffice/intercom.svg';
import PipedriveIcon from '../../../assets/img/backoffice/pipedrive.svg';
import StripeIcon from '../../../assets/img/backoffice/stripe.svg';
import { Subscription } from '../../../domain/backoffice/subscription/Subscription';
import { intl } from '../../../helpers/IntGlobalProvider';
import Text from '../../../react-components/Text';
import { InfoBox, InfoBoxItem, InfoBoxText } from './InfoBox';

export const generateIntercomLink = (email: string) => {
  const structure = {
    predicates: [
      {
        attribute: `role`,
        comparison: `eq`,
        type: `role`,
        value: `user_role`,
      },
      {
        attribute: `email`,
        comparison: `eq`,
        type: `string`,
        value: email,
      },
    ],
  };

  const jsonString = JSON.stringify(structure);
  const base64String = window.btoa(jsonString);

  return `https://app.intercom.com/a/apps/fmsiz9kk/users/segments/all-users:${base64String}`;
};

export const generateStripeCustomerLink = (stripeCustomerId: string) => {
  return `https://dashboard.stripe.com/customers/${stripeCustomerId}`;
};

export const generateStripeSubscriptionLink = (stripeSubscriptionId: string) => {
  return `https://dashboard.stripe.com/subscriptions/${stripeSubscriptionId}`;
};

export const generatePipedriveLink = (pipedrivePersonId: number) => {
  return `https://smartmonkey.pipedrive.com/deal/${pipedrivePersonId}`;
};

type SystemsInfoBoxProps = {
  email?: string;
  subscription: Subscription;
};

export const SystemsInfoBox = ({ email, subscription }: SystemsInfoBoxProps) => {
  return (
    <InfoBox title={intl.formatMessage({ id: `backoffice.systems` })}>
      <div style={{ height: `calc(100% - 32px)`, width: `calc(100% - 16px)`, padding: `0 8px` }}>
        {email ? (
          <InfoBoxItem
            label="Intercom"
            icon={<img src={IntercomIcon} style={{ width: `18px` }} alt="" draggable="false" />}
          >
            <InfoBoxText variant="button" onClick={() => window.open(generateIntercomLink(email), `_blank`)}>
              {email}
            </InfoBoxText>
          </InfoBoxItem>
        ) : null}

        <InfoBoxItem
          label="Customer"
          icon={<img src={StripeIcon} style={{ width: `18px` }} alt="" draggable="false" />}
        >
          {subscription.stripe_customer_id ? (
            <InfoBoxText
              variant="button"
              onClick={() => {
                window.open(generateStripeCustomerLink(subscription.stripe_customer_id!), `_blank`);
              }}
            >
              {subscription.stripe_customer_id}
            </InfoBoxText>
          ) : (
            <Text variant="label" intlId="none" />
          )}
        </InfoBoxItem>

        <InfoBoxItem
          label="Subscription"
          icon={<img src={StripeIcon} style={{ width: `18px` }} alt="" draggable="false" />}
        >
          {subscription.stripe_subscription_id ? (
            <InfoBoxText
              variant="button"
              onClick={() => {
                window.open(generateStripeSubscriptionLink(subscription.stripe_subscription_id!), `_blank`);
              }}
            >
              {subscription.stripe_subscription_id}
            </InfoBoxText>
          ) : (
            <Text variant="label" intlId="none" />
          )}
        </InfoBoxItem>

        <InfoBoxItem
          label="Pipedrive"
          icon={<img src={PipedriveIcon} style={{ width: `18px` }} alt="" draggable="false" />}
        >
          {subscription.pipedrive_person_id !== undefined ? (
            <InfoBoxText
              variant="button"
              onClick={() => {
                window.open(generatePipedriveLink(subscription.pipedrive_person_id!), `_blank`);
              }}
            >
              {subscription.pipedrive_person_id}
            </InfoBoxText>
          ) : (
            <Text variant="label" intlId="none" />
          )}
        </InfoBoxItem>
      </div>
    </InfoBox>
  );
};
